import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../../../js/components/react/Dropdown';

const InsightsCenterFacetList = ({
  initialFacets,
  selectedFacets,
  onFiltersChange,
  onResetFilters,
  focusareaLabel,
  contenttypeLabel,
  resetBtnLabel,
  focusareaDropdownDefaultLabel,
  contenttypeDropdownDefaultLabel
}) => {
  const getSelectedOption = facet => {
    if (selectedFacets[facet.keyword]) {
      const option = facet.options.find(
        option => option.value === selectedFacets[facet.keyword]
      );

      if (option) {
        return {
          ...option,
          label: option.name
        };
      }
    }
  };
  return (
    <div className="insights-center-facet-list">

      {initialFacets.map(facet => (
        <Dropdown
          key={facet.keyword}
          options={facet.options.map(option => ({
            value: option.value,
            label: option.name
          }))}
          placeholder={facet.keyword === 'focusarea' ? focusareaDropdownDefaultLabel : contenttypeDropdownDefaultLabel }
          selectedOption={getSelectedOption(facet)}
          label={facet.keyword === 'focusarea' ? focusareaLabel : contenttypeLabel}
          onChange={e => {
            onFiltersChange(facet.keyword, e.value);
          }}
          disabled={!facet.options.length}
        />
      ))}

      {!!Object.keys(selectedFacets).length && (
        <div className="insights-center-facet-list__reset">
          <button className="btn-v2 btn--primary btn--small" onClick={onResetFilters}>
            <div className="btn-content">{resetBtnLabel}</div>
          </button>
        </div>
      )}
    </div>
  );
};

InsightsCenterFacetList.propTypes = {
  initialFacets: PropTypes.array,
  resetBtnLabel: PropTypes.string
};

export default InsightsCenterFacetList;
